export const convertLevelText = (difficulty: string): string => {
  const difficultyMap: Record<string, string> = {
    BEGINNER: "beginner",
    INTERMEDIATE: "intermediate",
    ADVANCED: "advanced",
    EXPERT: "expert",
  };
  return difficultyMap[difficulty] || "";
};
